import React from 'react';
import { Col, Row, Input } from 'antd';
import RequestTypes from './RequestTypes';
import WatchedAndRepliedTypes from './WatchedAndRepliedTypes'
const Search = Input.Search;

const TopPanel = props => {
  const {
    typesList,
    onChangeTypeList,
    onChangeSearch,
    handleSearchRequests,
    requestsType,
    searchFieldValue,
    watchedTypes,
    repliedTypes,
    onChangeWatchedList,
    watched,
    replied,
    onChangeRepliedList,
  } = props;

  return (
    <div className="b-table-filters">
      <Row>
        <Col span={18}>
          <div className="orders__states">
            <RequestTypes
              typesList={typesList}
              value={requestsType}
              onChangeTypeList={onChangeTypeList}
            />
          </div>
        </Col>
        <Col span={6}>
          <Search
            placeholder="Поиск по заявкам"
            onChange={onChangeSearch}
            value={searchFieldValue}
            allowClear={true}
            onSearch={handleSearchRequests}
            style={{ width: '100%' }}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <WatchedAndRepliedTypes
            watchedTypes={watchedTypes}
            repliedTypes={repliedTypes}
            watched={watched}
            replied={replied}
            onChangeWatchedList={onChangeWatchedList}
            onChangeRepliedList={onChangeRepliedList}
          />
        </Col>
      </Row>
    </div>
  );
};

export default (TopPanel);
